// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button-wrapper {
  display: flex;
  flex-direction: column;
}
.button-wrapper .criteria-buttons {
  display: flex;
  align-self: flex-end;
  justify-content: flex-end;
  width: 100%;
}
.button-wrapper .criteria-buttons a {
  padding: 1rem;
  align-self: center;
}
.button-wrapper .criteria-buttons a.disabled {
  pointer-events: none;
  cursor: default;
  align-self: center;
  color: #bdbdbd;
}
.button-wrapper .criteria-buttons .extra-button-wrapper {
  display: flex;
}
.button-wrapper .criteria-buttons .extra-button-wrapper > * {
  padding: 1rem;
  width: 16rem;
  flex-grow: 1;
}
.button-wrapper .criteria-buttons .search {
  padding-right: 0 !important;
}
.button-wrapper .criteria-buttons .control-button {
  width: 16rem;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/kit/components/Search/SearchWithCriteria/SearchControlSection/index.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,sBAAA;AADF;AAGE;EACE,aAAA;EACA,oBAAA;EACA,yBAAA;EACA,WAAA;AADJ;AAGI;EACE,aAAA;EACA,kBAAA;AADN;AAII;EACE,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,cAAA;AAFN;AAKI;EACE,aAAA;AAHN;AAKM;EACE,aAAA;EACA,YAAA;EACA,YAAA;AAHR;AAOI;EACE,2BAAA;AALN;AAQI;EACE,YAAA;EACA,aAAA;AANN","sourcesContent":["@use '@Styles/variables';\n\n.button-wrapper {\n  display: flex;\n  flex-direction: column;\n\n  .criteria-buttons {\n    display: flex;\n    align-self: flex-end;\n    justify-content: flex-end;\n    width: 100%;\n\n    a {\n      padding: 1rem;\n      align-self: center;\n    }\n\n    a.disabled {\n      pointer-events: none;\n      cursor: default;\n      align-self: center;\n      color: variables.$grayColor4;\n    }\n\n    .extra-button-wrapper {\n      display: flex;\n\n      > * {\n        padding: 1rem;\n        width: 16rem;\n        flex-grow: 1;\n      }\n    }\n\n    .search {\n      padding-right: 0 !important;\n    }\n\n    .control-button {\n      width: 16rem;\n      padding: 1rem;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
